//coded by Narain on (11/09/2024)

import feature1 from '../assets/images/features/feature-1.png';
import feature2 from '../assets/images/features/feature-2.png';
import feature3 from '../assets/images/features/feature-3.png';

const features = [
  {
    image: feature1,
    title: "API Spec Q1 – Quality Management",
    body: "Hello! I'm here to provide answers on QMS Standards, including API and ISO. How can I assist you?",
    alt: "API Spec Q1"
  },
  {
    image: feature2,
    title: "API Spec Q2 – Risk Management",
    body: "Optimize service with AI-driven risk identification and API Spec Q2 compliance.",
    alt: "API Spec Q2"
  },
  {
    image: feature3,
    title: "API Monogram – Easy Certification",
    body: "Simplify API Monogram certification with our AI consulting for enhanced compliance.",
    alt: "API Monogram"
  }
];

export default features;
